import React from 'react';
import ContactForm from './ContactForm';

import * as API from '../api';
import * as globals from '../globals';

export default class SendMessageForm extends React.Component {
  state = { show: true };

  componentDidMount() {
    console.log('checking email enabled');
    console.log(this.props.pracKey);
    console.log(globals.serverURL);
    API.post(['emailEnabled'], {
      pracKey: this.props.pracKey,
    }).catch(err => {
      console.log(err);
      this.setState({ show: false });
    });
    console.log('done cdm');
  }

  render() {
    if (this.state.show === false) return null;
    const { pracKey } = this.props;
    return (
      <div className="section">
        <h3 className="sectiontitle">Send a message</h3>
        <div className="sectionitem" style={{ flex: 1 }}>
          <div style={{ marginBottom: '5px' }}>
            <small>
              Send a message to this practice and they'll get back to you.
            </small>
          </div>
          <ContactForm pracKey={pracKey} />
        </div>
      </div>
    );
  }
}
